import * as React from "react";
import * as CH from "@chakra-ui/react";
import { get } from "lodash-es";
import { ListItemElement, ElementProps } from "../../duck";
import { ListItem } from "./components";

const Element: React.FC<ElementProps> = ({
  elementTypeProps = {},
  ...rest
}) => {
  const { element, attributes, children } = rest;
  const elementProps = get(elementTypeProps, element.type);

  switch (element.type) {
    case "bulleted-list":
      return (
        <CH.UnorderedList
          my={4}
          mx={0}
          {...attributes}
          {...elementProps}
          display="flex"
          flexDirection="column"
          listStylePosition="inside"
        >
          {children}
        </CH.UnorderedList>
      );

    case "list-item":
      return (
        <ListItem
          element={element as ListItemElement}
          elementProps={elementProps}
          attributes={attributes}
        >
          {children}
        </ListItem>
      );

    case "numbered-list":
      return (
        <CH.OrderedList
          my={4}
          mx={0}
          display="flex"
          flexDirection="column"
          {...attributes}
          {...elementProps}
          listStylePosition="inside"
        >
          {children}
        </CH.OrderedList>
      );

    default:
      return (
        <CH.Text my={4} {...attributes}>
          {children}
        </CH.Text>
      );
  }
};

export default Element;
